import axios from "axios"; //引入
// import { getSession } from '@/store'
// import router from "@/router"
import secret from "@/utils/secret";
import cfg from "@/config/index";

let config = {
  baseURL: cfg.BASE_URL_WS,
  timeout: 180000, //设置最大请求时间
};
const _axios = axios.create(config);

/* 请求拦截器（请求之前的操作） */
_axios.interceptors.request.use(
  (config) => {
    //如果有需要在这里开启请求时的loading动画效果
    var sess = localStorage.getItem('sessionKey');
    if (sess) {
      config.headers.sessionKey = sess; //添加token
    }
    return config;
  },
  (err) => Promise.reject(err)
);

/* 请求之后的操作 */
_axios.interceptors.response.use(
  (res) => {
    //在这里关闭请求时的loading动画效果
    //这里用于处理返回的结果，比如如果是返回401无权限，可能会是跳回到登录页的操作，结合自己的业务逻辑写
    if (res.data.code !== 200) {
      // Toast(res.data.msg)
      //var next = () => { };
      if (res.data.code === 101) {
        // next = () => {
        //     router.push("/");//跳转首页
        // };
        //Notify({ type: 'warning', message: res.data.msg + ",即将跳转", onClose: next });
      } else {
        //Notify({ type: 'warning', message: res.data.msg, onClose: next });
      }
    }
    return res;
  },
  (err) => {
    if (err) {
      //在这里关闭请求时的loading动画效果
      // Toast("请求网络失败")
      //Notify({ type: 'danger', message: '请求网络失败' });
    }
    return Promise.reject(err);
  }
);

//封装post,get方法
const http = {
  get(url = "", params = {}) {
    //params["s"] = secret.create();
    return new Promise((resolve, reject) => {
      _axios({
        url,
        params,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        method: "GET",
      })
        .then((res) => {
          resolve(res.data);
          return res;
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post(url = "", params = {}) {
    return new Promise((resolve, reject) => {
      _axios({
        url,
        data: params,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        method: "POST",
      })
        .then((res) => {
          resolve(res.data);
          return res;
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default http;
